import * as React from "react";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { TextField, Autocomplete, Button, Checkbox, CircularProgress } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useForm, Controller, FieldValues } from "react-hook-form";
import { FundModel } from "../../util/All_interfaces";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";
import { postApiCall } from "../../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { ToastMessage } from "../../util/ToastMessage";
import { useDispatch } from "react-redux";
import { UserContext, updateUserContext } from "../../../redux/slices/userContextSlice";
import { getProfile } from "../../../services/userContext";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const FundNewForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const userId = params.userRoleId;

  const [loading, setLoading] = useState(false);

  const [postFormdata, setPostFormData] = useState<FundModel>({
    fundID: '',
    fundName: '',
    region: '',
    id: '',
    createdBy: '',
    created: '',
    lastModifiedBy: '',
    lastModified: ''
  });

  const [postFormdataError, setPostFormdataError] = useState<any>({
    fundID: false,
    fundName: false,
    region: false,
    id: false,
    createdBy: false,
    created: false,
    lastModifiedBy: false,
    lastModified: false
  });

  const [selectValue, setValue] = React.useState("External");
  const [regionList, setRegionList] = useState([{ title: "US", id: 1 },
  { title: "EMEA", id: 2 }, { title: "APAC", id: 3 }]);

  const { control, handleSubmit } = useForm({});

  const [postDataMessage, setPostDataMessage] = useState<{ code: number, message: string, isError: boolean }>({ code: 0, message: "", isError: false });

  const currentUserData: CurrentUser = useAppSelector((state) => state.currentUser.data);
  const userContext: UserContext = useAppSelector((state) => state.UserContext.data);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };

  const handleRegionChangeAndDateTime = (value: any) => {

    let today = new Date();
    let date = today.getDate() + "-" + today.getMonth() + 1 + "-" + today.getFullYear() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var selectedRegions = '';

    if (value.length == 0) {
      selectedRegions = '';
    } else {
      var tempRegions: any[] = [];
      value.forEach((element: { title: any; }) => {
        tempRegions.push(element.title);
      });
      var sortedTempRegions = tempRegions.sort().reverse();

      sortedTempRegions.forEach((element: any) => {
        if (selectedRegions == '') {
          selectedRegions = element;
        } else {
          selectedRegions = selectedRegions + ";" + element;
        }
      });
    }

    setPostFormData({
      ...postFormdata, region: selectedRegions, createdBy: currentUserData.email,
      created: date, lastModified: date, lastModifiedBy: currentUserData.email
    });
  }

  const submitForm = () => {
    setLoading(true);

    if (postFormdata.fundName.length === 0 ||
      postFormdata.fundID.length === 0 ||
      postFormdata.region.length === 0) {
      setLoading(false);
      setPostDataMessage({ code: 0, message: "Please correct the validation errors!", isError: true });

      setTimeout(() => {
        setPostDataMessage({ code: 0, message: "", isError: false });
      }
        , 1500);
    } else {
      setPostDataMessage({ code: 0, message: "", isError: false });
      postData();
    }
  }

  const postData = async () => {

    await postApiCall(`${TaskmgmtServiceURL}/Funds/Save`, postFormdata, ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => {
      setLoading(false);

      if (data.result == true) {
        setPostDataMessage({ code: 0, message: "Fund already exists", isError: true });
      } else {
        setPostDataMessage({ code: 1, message: "Fund has been submitted", isError: false });

          navigate(`/funds/list/`);
      }

    }).catch((e: any) => {
      setPostDataMessage({ code: e.response.status, message: "An error occurred while processing the request", isError: true });
      console.log(e);

      setLoading(false);
    });
  }

  useEffect(() => {
    if (Object.keys(userContext).length == 0) {
      getProfile(true).then((data: any) => {

        dispatch(updateUserContext(data));
      });
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    if (Object.keys(userContext).length != 0) {
      setLoading(false);
      var regionContext = userContext.region;
      if (regionContext != '') {
        if (regionContext == 'US;EMEA') {
          setRegionList(
            [{ title: "US", id: 1 },
            { title: "EMEA", id: 2 }])
        }
        else if (regionContext == 'US;APAC') {
          setRegionList(
            [{ title: "US", id: 1 },
            { title: "APAC", id: 2 }])
        }
        else if (regionContext == 'EMEA;APAC') {
          setRegionList(
            [{ title: "EMEA", id: 1 },
            { title: "APAC", id: 2 }])
        }
      }

    }

  }, [userContext]);

  return (
    <div className="form-wrap">

      <Box sx={{ width: "100%", typography: "body1" }}>

        {postDataMessage.isError ?
          <ToastMessage message={postDataMessage.message} severity="error" />
          : null}
        {postDataMessage.code == 1 ?
          <ToastMessage message={postDataMessage.message} severity="success" />
          : null}
        {loading ? (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        ) : null}
        <Grid container spacing={3}>
          <Grid item xs={8} sm={8}>
            <Controller
              name="FundName"
              control={control}
              render={({ field }) => (
                <TextField
                  required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  label="Fund Name"
                  defaultValue=""
                  variant="outlined"
                  size="small"
                  fullWidth
                  onChange={
                    (event) => {
                      setPostFormData({ ...postFormdata, fundName: event.target.value });
                      setPostFormdataError({ ...postFormdataError, fundName: event.target.value.length === 0 });
                    }
                  }
                  error={postFormdataError.fundName}
                />
              )}
            />
          </Grid>
          <Grid item xs={8} sm={8}>
            <Controller
              name="FundID"
              control={control}
              render={({ field }) => (
                <TextField
                  required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  label="Fund ID"
                  defaultValue=""
                  variant="outlined"
                  size="small"
                  fullWidth
                  onChange={
                    (event) => {
                      setPostFormData({ ...postFormdata, fundID: event.target.value });
                      setPostFormdataError({ ...postFormdataError, fundID: event.target.value.length === 0 });
                    }
                  }
                  error={postFormdataError.fundID}
                />
              )}
            />
          </Grid>
          <Grid item xs={8} sm={8}>
            <Controller
              name="Region"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  options={regionList}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.title}
                  onChange={(event, value) => {
                    handleRegionChangeAndDateTime(value);
                    setPostFormdataError({ ...postFormdataError, region: false || value.length == 0 });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected || postFormdata.region.includes(option.title)}
                      />
                      {option.title}
                    </li>
                  )}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      size="small"
                      required
InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={postFormdataError.region}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Button sx={{textTransform:"none"}} variant="contained" size="medium" color="success"
              onClick={() => {
                submitForm();
                setPostFormdataError({
                  ...postFormdataError,
                  fundName: postFormdata.fundName.length === 0,
                  fundID: postFormdata.fundID.length === 0,
                  region: postFormdata.region.length === 0
                });
              }}
            >
              Submit
            </Button>
            <Button sx={{textTransform:"none",ml: 2}}
              variant="outlined"
              size="medium"
              color="error"
              onClick={() => navigate("/funds/list")}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
